import axios from 'axios';
import React, { useState, useRef, useEffect } from "react";
import { VscLinkExternal } from "react-icons/vsc";
import { MaterialReactTable } from 'material-react-table';
import { Oval } from 'react-loader-spinner';
import AdminAddTemplate from './Admin-AddTemplate';
import { ToastContainer, toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import {
    Box,
    Typography,
    Tooltip,
    Button,
    IconButton
} from '@mui/material';

import "../../styles/Admin-ui/Admin-DoctorsList.css";
import { API_DETAILS, COOKIE_KEYS, USER_TYPES } from '../../App';
import AdminSideBar from './Admin-SideBar';
import AdminPopUps from './Admin-PopUps';
import Cookies from "js-cookie";
import Youroheader from '../Youro-header';
import "../../styles/Admin-ui/Admin-PopUps.css";
import Popup from 'reactjs-popup';

import { useNavigate } from 'react-router-dom';
import { MdEdit } from "react-icons/md";
import EditIcon from '@mui/icons-material/Edit';
const AdminNoteTemplateList = () => {
    const [showAddTemplatePopup, setShowAddTemplatePopup] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [renderAdmin, setRenderAdmin] = useState(false);
    const [renderApiData, setRenderApiData] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false); 
    const [selectedNoteTemplate, setSelectedNoteTemplate] = useState(''); 
    const [selectedTemplateForEdit, setSelectedTemplateForEdit] = useState(null); 
    const navigate = useNavigate();
    const [message,setMessage] =  useState("");

    useEffect(() => {
        fetchData();
    }, []);
    const handleAddTemplate = () => {
        setShowAddTemplatePopup(true);
    };

    const handleCloseAddTemplatePopup = () => {
        setShowAddTemplatePopup(false);
        setSelectedTemplateForEdit(null);
        refreshData();
    };

    const fetchData = async () => {
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllTemplates`;
        
        try {
            const res = await axios.get(url,config);
            setRenderAdmin(true);
            const filteredData = res.data.filter(item => !item.softDelete);
            setTableData(filteredData);
        } catch (err) {
            setRenderApiData(true);
            console.error(err);
        }
    };
    const refreshData = () => {
        fetchData(); // Call fetchData to fetch updated data
    };


    const handleClick = async (row) => {
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getNoteTemplate/${row.original.diag_id}/${row.original.type}`
        try {
            const res = await axios.get(url,config);
            console.log("edit response : ",res.data);
            setSelectedTemplateForEdit(res.data); // Assuming res.data contains the template data
            setShowAddTemplatePopup(true);
        } catch (err) {
            console.error(err);
        }
    };

    const renderRowActions = ({ row }) => (
        <Box sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip arrow placement="right" title="Delete">
            <AdminPopUps data={{ 'action': 'delete-note-template', 'step': 1, 'rowData': row.original }} refreshData={refreshData} />

            </Tooltip>
            <Tooltip arrow placement="right" title="Edit">
                {/*<button onClick={() => handleClick(row)} className='edit-button'>
                    <MdEdit />
    </button>*/}
                <IconButton
                     color="gray"
                     onClick={() => handleClick(row)}
                     className='edit-button'
                 >
                     <EditIcon />
                </IconButton>
            </Tooltip>
            
            {/*<Tooltip arrow placement="right" title="External Link">
                <VscLinkExternal onClick={() => handleExternalLinkClick(row)} />
    </Tooltip>*/}
        </Box>
    );

    const columns = [
        {
            accessorKey: 'diagnosis_name',
            header: 'Questionnaires',
        },
        {
            accessorKey: 'type',
            header: 'Type',
        }
    ];

    return (
        <div>
            <div className='hm'>
                <div className='sidebar'>
                    <AdminSideBar data={'admin-note-template'} />
                </div>
                <div className="admin-ui-table">
                    <div className='header' style={{ marginLeft: '15px' }}>
                        <Youroheader />
                    </div>
                    
                    <div className="template-container" style={{ marginLeft: '15px' }}>
                        
                            <div className='btn-filled' style={{ display: 'inline-block' }} onClick={handleAddTemplate}>Add Template</div>
                        
                    </div>
                    
                    {/*<Box sx={{ display: 'flex', gap: '1rem', marginLeft: '15px' }}>
                                    <Tooltip arrow placement="left" title="Add Template">
                                        <IconButton color="gray" onClick={handleAddTemplate} className='add-icon' size="large">
                                            <AddIcon fontSize='inherit' />
                                        </IconButton>
                                    </Tooltip>
</Box>*/}
                                
                    {renderAdmin && tableData && tableData.length > 0 ? (
                        <MaterialReactTable
                            displayColumnDefOptions={{
                                'mrt-row-actions': {
                                    muiTableHeadCellProps: {
                                        align: 'center',
                                    },
                                    size: 120,
                                },
                            }}
                            columns={columns}
                            data={tableData}
                            enableStickyHeader
                            enableColumnOrdering
                            enableRowActions
                            enableEditing={false}
                            muiTableContainerProps={{ sx: { maxHeight: window.innerHeight } }}
                            positionActionsColumn='last'
                            renderRowActions={renderRowActions}
                            muiTableBodyProps={{
                                sx: () => ({
                                    '& tr:nth-of-type(odd)': {
                                        backgroundColor: "lightgray",
                                    },
                                }),
                            }}
                        />
                    ) : renderApiData ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "98%", borderRadius: '10px', height: '70vh' }}>
                            Error Fetching Data!
                        </div>
                    ) : !renderAdmin ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "98%", borderRadius: '10px', height: '70vh' }}><Oval /></div>
                    ) : (
                        renderAdmin && tableData && tableData.length === 0 && (
                            <div style={{ textAlign: 'center', width: "98%", borderRadius: '10px', height: '70vh' }}>
                                No Data Found!
                            </div>
                        )
                    )}
                </div>
            </div>
            <Popup
                open={showAddTemplatePopup}
                onClose={handleCloseAddTemplatePopup}
                modal
                nested
                contentStyle={{
                    width: '80%',
                    height: 'auto',
                    maxHeight: '80vh',
                    padding: '20px',
                    borderRadius: '10px',
                    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)',
                    overflowY: 'hidden', 
                    textAlign: 'center',
                }}
            >
                <div className="popup-content-admin" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 style={{ margin: 'auto' }}>{selectedTemplateForEdit ? 'Edit' : 'Add'} Template</h2>
                        <div style={{ fontSize: '24px', cursor: 'pointer' }} onClick={handleCloseAddTemplatePopup}>&times;</div>
                    </div>
                    <div className="modal-body" style={{ flexGrow: 1 }}>
                        <AdminAddTemplate templateData={selectedTemplateForEdit} onClose={handleCloseAddTemplatePopup} setShowAddTemplatePopup ={setShowAddTemplatePopup}/>
                    </div>
                </div>
            </Popup>

            <Popup
                open={isPopupOpen}
                closeOnDocumentClick
                onClose={() => setIsPopupOpen(false)}
                modal
            >
                <div className="popup-content-admin">
                    <div className='row'>
                        <div className='col-12 info-col'>
                            <h3 style={{ marginLeft: '5%' }}>Notes:</h3>
                        </div>
                        <div className='col-12 content-col'>
                            <Typography>{selectedNoteTemplate}</Typography>
                        </div>
                        <div className='col-12 buttons-col row'>
                            <div className='col-6'></div>
                            <div className='col-6'>
                                <Button onClick={() => setIsPopupOpen(false)} variant="contained" color="primary">
                                    Close
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
            <ToastContainer />
        </div>
    );
};

export default AdminNoteTemplateList;
